// Helper para registrar actividad multimedia (uploads / vistas / descargas)
// desde el frontend público. Fire-and-forget: no bloquea la UI ni reporta
// errores, y deduplica eventos por sesión para no inundar la BD.

const API_URL = process.env.REACT_APP_BACKEND_URL || '';
const SS_INV = 'webAuthInvitado';

// Cache de eventos ya enviados en esta sesión: clave `${accion}|${origen}|${archivo_url}`
const sentInSession = new Set();

const getInvitado = () => {
  try { return JSON.parse(sessionStorage.getItem(SS_INV) || 'null'); } catch { return null; }
};

/**
 * Registra un evento multimedia.
 * @param {Object} opts
 * @param {'upload'|'view_thumb'|'view_full'|'download'} opts.accion
 * @param {'galeria'|'carrusel'|'intro'} opts.origen
 * @param {string} opts.archivo_url
 * @param {string} [opts.archivo_nombre]
 * @param {string} [opts.archivo_tipo]  - 'foto' | 'video' | 'imagen'
 * @param {boolean} [opts.once=true]    - si true, no repite el mismo evento en la sesión
 */
export const trackMediaActivity = ({
  accion,
  origen,
  archivo_url,
  archivo_nombre = '',
  archivo_tipo = '',
  once = true,
}) => {
  if (!accion || !origen || !archivo_url) return;
  const key = `${accion}|${origen}|${archivo_url}`;
  if (once && sentInSession.has(key)) return;
  sentInSession.add(key);

  const inv = getInvitado();
  const payload = {
    accion,
    origen,
    archivo_url,
    archivo_nombre: archivo_nombre || (archivo_url.split('/').pop() || ''),
    archivo_tipo,
    invitado_id: inv?.id || '',
    invitado_nombre: inv?.nombre || '',
    invitado_telefono: inv?.telefono || '',
  };

  try {
    // Fire-and-forget: no esperamos la respuesta.
    fetch(`${API_URL}/api/public/media-actividad`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => { /* silenciar */ });
  } catch {
    /* silenciar */
  }
};
